import * as React from 'react';
import * as PropTypes from "prop-types";

var omitBy = require("lodash/omitBy");

var isUndefined = require("lodash/isUndefined");

export var RenderComponentPropType = PropTypes.oneOfType([function (props, propName) {
  if (isUndefined(props[propName]) || props[propName]["prototype"] instanceof React.Component) {
    return null;
  }
}, PropTypes.element, PropTypes.func]);
export function renderComponent(component) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var children = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isReactComponent = component["prototype"] instanceof React.Component || component["prototype"] && component["prototype"].isReactComponent || typeof component === 'function';

  if (isReactComponent) {
    return React.createElement(component, props, children);
  } else if (React.isValidElement(component)) {
    return React.cloneElement(component, omitBy(props, isUndefined), children);
  }

  console.warn("Invalid component", component);
  return null;
}